export const LOADER = 'LOADER';
export const UNLOADER = 'UNLOADER';
